import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const LinkClickLogger = () => {
  const location = useLocation();

  useEffect(() => {
    console.log("User navigated to:", location.pathname);
    console.log("Full URL:", window.location.href);
  }, [location.pathname]); // fires ONLY when route changes

  return null;
};

export default LinkClickLogger;
